<template>
    <div class="CourseIntroduction">
        <h2>课程介绍</h2>
        <div class="speakerCont">
            <p v-text="abstract"></p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            abstract:''
        }
    },
    mounted(){
		this.abstract = this.$route.params.abstract;
		
        // 获取unix时间戳到秒
        // let timestamp = Date.parse(new Date())/1000;

        // 获取课程id
   //      let courseId = this.$route.params.id;
   //      let data = {
   //          "TimeStamp":timestamp,
   //          "ID":courseId
   //      }
   //      this.$axios.post(Const_Api_Root+'api/Course/Info',data,{
   //          contentType: 'application/json',
   //          dateType:'JSON',
   //          xHrFields: {withCredentials:true},
			// beforeSend: function (XHR) {
			// 	XHR.withCredentials = true;  // 跨域cookie支持代码
			// }
   //      }).then((res)=>{
   //          // 错误提示
   //          if(res.data.Status == 0){
   //              this.abstract = res.data.Data.Abstract;
   //          }else if(res.data.Status != -2){
   //              this.$message({
   //                  message: res.data.Data,
   //                  type: 'error',
   //                  duration: 3000
   //              });
   //          }
   //      }).catch((err)=>{
   //          throw err;
   //      });
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .CourseIntroduction{
        width: 100%;
        h2{
            font-size: 20px;
            margin-bottom: 20px;
        }
        img{
            width: 259px;
            height: 219px;
        }
    }
}
@media screen and (min-width: 1029px) {
    .CourseIntroduction{
        width: 740px;
        margin: 0 auto 100px;
        h2{
            font-size: 30px;
            margin-bottom: 20px;
        }
        .speakerCont{
            margin-bottom: 50px;
        }
        img{
            max-width: 740px;
            height: auto;
        }
    }
    
}
// 公用
h2{
    color: #19191A;
    letter-spacing: 0;
    text-align: center;
}
.speakerCont{
    margin-bottom: 50px;
    p{
        font-size: 14px;
        color: rgba(25,25,26,0.80);
        line-height: 28px;
        text-indent: 30px;
    }
    .picBox{
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/class/CourseIntroduction.vue